import { object, string } from 'yup';
import { isPhone } from 'brazilian-values';

export default object().shape({
  name: string().required('Informe o nome'),
  email: string().email('Favor insira seu email corretamente').required('Infome o e-mail'),
  phoneNumber: string().min(11, 'Informe um telefone válido').test('is-valid-phone', 'Informe um telefone válido', isPhone).required('Informe o telefone'),
})